module.exports = __webpack_public_path__ + "static/media/edit-dash.08fcf577.svg";